import {routerMiddleware} from 'connected-react-router';
import {applyMiddleware, createStore} from 'redux';
import {createEpicMiddleware} from 'redux-observable';
import {RootAction, RootState, ServiceContext} from 'typesafe-actions';

import {history} from '../routes';
import contextServices from '../services';
import {loadState, storeListener} from './freeze';
import rootEpic from './root-epic';
import rootReducer from './root-reducer';
import {composeEnhancers} from './utils';

export const epicMiddleware = createEpicMiddleware<
  RootAction,
  RootAction,
  RootState,
  ServiceContext
>({
  dependencies: contextServices,
});

// configure middlewares
const middlewares = [routerMiddleware(history), epicMiddleware];

// compose enhancers
const enhancer = composeEnhancers(applyMiddleware(...middlewares));

// rehydrate state on app start
const initialState = loadState();

// create store
const store = createStore(rootReducer, initialState, enhancer);

// Save state in SessionStorage
storeListener(store);

// Listen Epics from Redux-observable
epicMiddleware.run(rootEpic);

// export store singleton instance
export default store;



// WEBPACK FOOTER //
// ./src/store/index.ts